<template>
  <div class="alert-container">
    <TransitionGroup name="alert-slide">
      <div v-for="alert in alerts" :key="alert.id" :class="['app-alert', `alert-${alert.type}`]">
        <div class="alert-content">
          <div class="alert-message">{{ alert.message }}</div>
        </div>
        <button class="alert-close" @click="closeAlert(alert.id)">✕</button>
      </div>
    </TransitionGroup>
  </div>
</template>

<script>
export default {
  name: 'AppAlert',
  props: {
    alerts: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    closeAlert(id) {
      this.$emit('close', id);
    }
  }
}
</script>

<style scoped>
.alert-container {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
}

.app-alert {
  min-width: 400px;
  max-width: 600px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: var(--border-radius);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  pointer-events: auto;
  border: none;
}

.alert-success {
  background: linear-gradient(135deg, #52c41a 0%, #73d13d 100%);
  color: white;
}

.alert-error {
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  color: white;
}

.alert-info {
  background: linear-gradient(135deg, #1890ff 0%, #40a9ff 100%);
  color: white;
}

.alert-content {
  flex: 1;
  min-width: 0;
}

.alert-message {
  font-size: 14px;
  color: white;
  line-height: 1.5;
  font-weight: 500;
}

.alert-close {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  padding: 4px 8px;
  cursor: pointer;
  color: white;
  font-size: 16px;
  line-height: 1;
  transition: background 0.15s;
  flex-shrink: 0;
  border-radius: var(--border-radius);
}

.alert-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Animations */
.alert-slide-enter-active {
  transition: all 0.25s ease-out;
}

.alert-slide-leave-active {
  transition: all 0.2s ease-in;
}

.alert-slide-move {
  transition: transform 0.3s ease;
}

.alert-slide-enter-from {
  transform: translateY(-20px);
  opacity: 0;
}

.alert-slide-leave-to {
  transform: scale(0.95);
  opacity: 0;
}
</style>
